/* eslint-disable */
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import configureStore from './store'
import './index.css'
import 'bootstrap/dist/css/bootstrap.css';

import { store } from './store';

import Routes from './routes'

document.getElementById('loading').remove();
document.getElementById('root').classList.remove('ssr-remove');

ReactDOM.render(
  <Provider store={store}>
    <Routes />
  </Provider>
, document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/